const dispatchCustomEvent = function (identifier, detail = {}) {
  document.body.dispatchEvent(
    new CustomEvent(identifier, {
      bubbles: true,
      detail: detail,
    })
  );
};

export {
  dispatchCustomEvent
};
